exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".qrCode-ce92bfca{margin:30px auto;padding:5px;border:1px solid #E0E0E0;border-radius:4px;width:180px;height:180px;box-sizing:content-box}.secondaryDownload-8a0fcae5{color:#616161 !important;width:80px !important;padding-left:0 !important;padding-right:0 !important;text-align:right !important}\n", ""]);

// Exports
exports.locals = {
	"qrCode": "qrCode-ce92bfca",
	"secondaryDownload": "secondaryDownload-8a0fcae5"
};